/** Backend user_status values — keep in sync with ActiveChatUser API */
export const INTERVENE_USER_TABS = {
  INTERVENE: 'intervene',
  RECENT_15M: '15-min',
  ACTIVE_24H: 'active',
  HISTORY: 'history',
};

export const INTERVENE_LIST_PAGE_SIZE = 20;
export const INTERVENE_MESSAGE_PAGE_SIZE = 20;

export const INTERVENE_TAB_CONFIG = [
  { value: INTERVENE_USER_TABS.INTERVENE, label: 'My Chats', countKey: 'intervene' },
  { value: INTERVENE_USER_TABS.RECENT_15M, label: '15 Min', countKey: 'min_15' },
  { value: INTERVENE_USER_TABS.ACTIVE_24H, label: '24 HRS', countKey: 'hrs_24' },
  { value: INTERVENE_USER_TABS.HISTORY, label: 'History', countKey: 'history' },
];
